export default __webpack_public_path__ + "static/media/logo.d028d469.svg";